import { useIncidentAudio } from './../hooks/useIncidentAudio'
import { HiSpeakerWave } from 'react-icons/hi2'
import { useSelector } from 'react-redux'

import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  FormControl,
  FormLabel,
  HStack,
  Switch,
  VStack,
} from '@chakra-ui/react'

import { Card } from '@/components/ui'
import { selectAreNotificationsMuted } from '@/redux/notifications/notificationsSlice'
import { trackEvent } from '@/utils/analytics'

import { AUDIO_SETTINGS_ANALYTICS } from '../constants/constants'

export const AudioSetting = () => {
  const {
    toggleAudioEnabled,
    playAlertSound,
    isEnabled,
    isUpdatingAudioSetting,
  } = useIncidentAudio()

  const areNotificationsMuted = useSelector(selectAreNotificationsMuted)

  const testSound = async () => {
    trackEvent(AUDIO_SETTINGS_ANALYTICS.testAlert)
    await playAlertSound()
  }

  return (
    <Card
      _hover={{
        boxShadow: '0px 2px 5px 6px rgba(0, 0, 0, 0.15)',
      }}
      p='0'
      transition='ease-in-out'
      transitionDuration='300ms'
      transitionProperty='all'
    >
      <Box fontSize='20px' fontWeight='extrabold' letterSpacing='-0.6px' p='4'>
        Audio Settings
      </Box>

      <Box
        bgColor='#F0F5FD'
        borderBottom='1px solid #eaedf3'
        borderTop='1px solid #eaedf3'
        p='4'
      >
        <VStack alignItems='start' spacing={4}>
          <FormControl alignItems='center' display='flex'>
            <FormLabel htmlFor='audio-alerts' mb='0'>
              Enable Incident audio alerts?
            </FormLabel>
            <Switch
              id='audio-alerts'
              isChecked={isEnabled}
              isDisabled={isUpdatingAudioSetting}
              onChange={toggleAudioEnabled}
            />
          </FormControl>

          {isEnabled && (
            <VStack alignItems='start' spacing={3} width='100%'>
              <Alert borderRadius='md' status='info'>
                <HStack spacing={2}>
                  <AlertIcon />
                  <VStack alignItems='start' spacing={0}>
                    <AlertTitle mr={2}>Mute override</AlertTitle>
                    <AlertDescription>
                      Muting Incidents via the bell in the Active Incidents
                      drawer will override this feature. i.e. If you don't want
                      to see pop ups, you also won't be pinged.
                    </AlertDescription>
                  </VStack>
                </HStack>
              </Alert>

              {areNotificationsMuted && (
                <Alert borderRadius='md' status='warning'>
                  <HStack spacing={2}>
                    <AlertIcon />
                    <VStack alignItems='start' spacing={0}>
                      <AlertTitle mr={2}>Override enabled</AlertTitle>
                      <AlertDescription>
                        Incident audio alerts have been overridden via Active
                        Incidents mute button on bottom right. Audio alerts will
                        not be played as Incidents come in.
                      </AlertDescription>
                    </VStack>
                  </HStack>
                </Alert>
              )}

              <HStack spacing={2}>
                <Button
                  leftIcon={<HiSpeakerWave />}
                  onClick={testSound}
                  variant='primary'
                >
                  Test Alert
                </Button>
              </HStack>
            </VStack>
          )}
        </VStack>
      </Box>
    </Card>
  )
}
